export default __webpack_public_path__ + "static/poppins-v20-latin-ext-regular-3d7b6a76b91c47dac1198138cdc0c081.woff2";